import moment from "moment-business-days";
import constants from "./constants";

export default {
  toMoment(value) {
    if (!value) return null;
    return moment(value);
  },

  getDatesByQuickFilter(code) {
    let from = null;
    let to = null;
    switch (code) {
      // Hôm nay
      case constants.DATE_QUICK_FILTER.CODE.HOM_NAY:
        from = moment().startOf("day").toDate();
        to = moment().startOf("day").toDate();
        return [from, to];

      // Tuần này
      case constants.DATE_QUICK_FILTER.CODE.TUAN_NAY:
        from = moment().isoWeekday(1).startOf('isoWeek');
        to = moment().isoWeekday(1).endOf('isoWeek').startOf("day");
        return [from.toDate(), to.toDate()];

      // Tuần trước
      case constants.DATE_QUICK_FILTER.CODE.LAST_WEEK:
        from = moment().subtract(1, 'week').isoWeekday(1).startOf('isoWeek');
        to = moment().subtract(1, 'week').isoWeekday(1).endOf('isoWeek').startOf("day");
        return [from.toDate(), to.toDate()];

      // Tháng này
      case constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2:
      case constants.DATE_QUICK_FILTER.CODE.THIS_MONTH:
        to = moment().endOf("month").startOf("day");
        from = moment().startOf("month");
        return [from.toDate(), to.toDate()];

      // 30 ngày trước
      case constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS:
        to = moment().startOf("day");
        from = moment().startOf("day").add(-30, "days");
        return [from.toDate(), to.toDate()];

      // Tháng trước
      case constants.DATE_QUICK_FILTER.CODE.LAST_MONTH:
        from = moment().subtract(1, 'month').startOf('month');
        to = moment().subtract(1, 'month').endOf('month').startOf("day");
        return [from.toDate(), to.toDate()];

      // Năm nay
      case constants.DATE_QUICK_FILTER.CODE.NAM_NAY:
        from = moment().startOf("year");
        to = moment()
          .endOf("year")
          .startOf("day");
        return [from.toDate(), to.toDate()];

      // 365 ngày trước
      case constants.DATE_QUICK_FILTER.CODE.LAST_YEAR:
        to = moment().startOf("day");
        from = moment().startOf("day").add(-365, "days");
        return [from.toDate(), to.toDate()];

      // Năm trước
      case constants.DATE_QUICK_FILTER.CODE.LAST_YEAR_2:
        to = moment()
          .subtract(1, "years")
          .endOf("year")
          .startOf("day");
        from = moment().subtract(1, "years").startOf("year");
        return [from.toDate(), to.toDate()];

      case constants.DATE_QUICK_FILTER.CODE.TO_TRINH_QUA_HAN_DEFAULT_RANGE:
        to = moment().startOf("day").subtract(5, "day");
        from = moment(to).subtract(3, "month");
        return [from.toDate(), to.toDate()];

      default:
        return [null, null];
    }
  },

  getTimesByQuickFilter(code) {
    let dateRange = this.getDatesByQuickFilter(code);
    let from = dateRange[0];
    let to = dateRange[1];
    return [from ? from.getTime() : null, to ? to.getTime() : null];
  },

  getDiffBaseWorkingDay(date1, date2) {
    let date1_ = this.toMoment(date1);
    let date2_ = this.toMoment(date2);
    let diff = date1_.businessDiff(date2_);
    return diff;
  },

  isDiff(date1, date2) {
    return (
      (date1 && !date2) ||
      (!date1 && date2) ||
      (date1 && date2 && date1.getTime() !== date2.getTime())
    );
  },

  isSameDate(time1, time2) {
    let date1_ = new moment(time1)
      .startOf("day")
      .toDate()
      .getTime();
    let date2_ = new moment(time2)
      .startOf("day")
      .toDate()
      .getTime();
    return date1_ === date2_;
  },

  truncDate(time) {
    return time
      ? moment(time)
        .startOf("day")
        .toDate()
        .getTime()
      : null;
  }
};



// WEBPACK FOOTER //
// ./src/dateUtils.js